import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withStyles,
  AppBar,
  Toolbar,
  Typography,
  Icon,
  IconButton,
  Badge,
  LinearProgress,
} from '@material-ui/core';
import {
  toggleDrawer as toggleDrawerAction,
  showNotifications as showNotificationsAction,
} from '@pingum/app-state-management/app/actions';
import { openSupportRequestModal } from '@pingum/app-state-management/supportRequest/actions';
import { getTenantFromUrl } from '../../../utils/urlHelper';
import {
  loginRequest,
  signupRequest,
} from '../../../redux/auth/actions';
import NotificationList from '../NotificationList';
import UserMenu from '../../navigation/UserMenu';
import styles from './styles';

const getPadding = ({
  disableBottomGutter,
  disablePadding,
  classes,
}) => {
  if (disablePadding) {
    return classes.childrenContainerNoPadding;
  }

  if (!disableBottomGutter) {
    return classes.childrenContainer;
  }
  return classes.childrenContainerNoGutter;
};

class PageHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = { notificationAnchorElement: null };
  }

  handleNotificationButtonClick = (e) => {
    this.setState({ notificationAnchorElement: e.target });
    this.props.showNotifications();
  }

  render() {
    const {
      title,
      action,
      classes,
      unviewedNotificationCount,
      toggleDrawer,
      children,
      showLoadingIndicator,
      disableBottomGutter,
      disablePadding,
      hideMenuButton,
    } = this.props;
    return (
      <div className={classes.container}>
        <AppBar
          position="relative"
          color="inherit"
          elevation={2}
          className={classes.appBar}
        >
          <Toolbar>
            {
              !hideMenuButton
                && (
                  <IconButton
                    className={classes.menuButton}
                    aria-label="Open menu"
                    onClick={toggleDrawer}
                  >
                    <Icon>menu</Icon>
                  </IconButton>
                )
            }
            <Typography variant="h5" className={classes.title} noWrap>
              {title}
            </Typography>
            <div className={classes.grow} />
            {
              !!action
                && action
            }
            {
              (getTenantFromUrl() && !action)
              && (
                <IconButton
                  className={classes.menuButton}
                  onClick={this.handleNotificationButtonClick}
                >
                  <Badge
                    badgeContent={unviewedNotificationCount}
                    color="error"
                    invisible={!unviewedNotificationCount}
                  >
                    <Icon>
                      notifications
                    </Icon>
                  </Badge>
                </IconButton>
              )
            }
            {!action && <NotificationList anchorElement={this.state.notificationAnchorElement} />}
            {!action && <UserMenu />}
          </Toolbar>
          {
            children
              && (
                <div
                  className={getPadding({
                    disableBottomGutter,
                    disablePadding,
                    classes,
                  })}
                >
                  {
                  children
                }
                </div>
              )
          }
          {
            showLoadingIndicator
              && (
                <LinearProgress
                  classes={{ root: classes.progress }}
                />
              )
          }
        </AppBar>
      </div>
    );
  }
}

PageHeader.propTypes = {
  title: PropTypes.string,
  action: PropTypes.any,
  classes: PropTypes.object,
  unviewedNotificationCount: PropTypes.number,
  toggleDrawer: PropTypes.func,
  children: PropTypes.any,
  showLoadingIndicator: PropTypes.bool,
  showNotifications: PropTypes.func,
  disableBottomGutter: PropTypes.bool,
  disablePadding: PropTypes.bool,
  hideMenuButton: PropTypes.bool,
};

PageHeader.defaultProps = {
  title: '',
  action: null,
  classes: {},
  unviewedNotificationCount: 0,
  toggleDrawer: () => {},
  children: null,
  showLoadingIndicator: false,
  showNotifications: () => {},
  disableBottomGutter: false,
  disablePadding: false,
  hideMenuButton: false,
};

export const mapStateToProps = (state) => ({
  auth: state.auth,
  user: state.user.user,
  unviewedNotificationCount: state.userNotification.unviewedNotificationCount,
});

export const mapDispatchToProps = (dispatch) => ({
  login: () => dispatch(loginRequest()),
  openSupportRequestModal: () => dispatch(openSupportRequestModal()),
  signup: () => dispatch(signupRequest()),
  toggleDrawer: () => dispatch(toggleDrawerAction()),
  showNotifications: () => dispatch(showNotificationsAction()),
});

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(PageHeader));
